module.exports = __webpack_public_path__ + "static/media/header_ico_close.eb7709c4.svg";